import {CREATE, DELETE, fetchUtils, GET_LIST, GET_MANY, GET_MANY_REFERENCE, GET_ONE, UPDATE,} from "react-admin";

var _ = require('lodash');

export default (apiUrl: string, httpClient = fetchUtils.fetchJson) => {
    /**
     * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
     * @param {String} resource Name of the resource to fetch, e.g. 'posts'
     * @param {Object} params The data request params, depending on the type
     * @returns {Object} { url, options } The HTTP request parameters
     */
    const convertDataRequestToHTTP = (type: string, resource: string, params: any) => {
        let url = "";
        const options: any = {};
        switch (type) {
            case GET_LIST: {
                let queryString = '';
                if (params.filter != null) {
                    queryString = '&' + Object.entries(params.filter).map(([key, value]: any) => key + "=" + value).join("&");
                }
                const {page, perPage} = params.pagination;
                let sort = '';
                if (params.sort != null) {
                    sort = `&sort=${params.sort.field},${params.sort.order}`;
                }
                url = `${apiUrl}/${resource}?page=${page - 1}&size=${perPage}${queryString}${sort}`;
                break;
            }
            case 'GET_TREE': {
                let queryString = '';
                if (params.filter != null) {
                    queryString = '&' + Object.entries(params.filter).map(([key, value]: any) => key + "=" + value).join("&");
                }
                let sort = '';
                if (params.sort != null) {
                    sort = `&sort=${params.sort.field},${params.sort.order}`;
                }
                url = `${apiUrl}/${resource}?${queryString}${sort}`;
                break;
            }
            case GET_ONE:
                url = `${apiUrl}/${resource}/${params.id}`;
                break;
            case GET_MANY: {
                const query = {
                    filter: JSON.stringify({id: params.ids})
                };
                let idStr = "";
                const queryString = params.ids.map((id: any) => idStr + `id=${id}`).join('&');

                url = `${apiUrl}/${resource}?${queryString}`;
                break;
            }
            case GET_MANY_REFERENCE: {
                let idStr = "";
                console.log(params);
                const queryString = params.target+`=${params.id}`;
                url = `${apiUrl}/${resource}?${queryString}`;
                break;
            }
            case UPDATE:
                console.log(params.data)
                if (_.find(params.data.images, 'rawFile'))
                    convertMediaItems(params.data.images).then(images => {
                        params.data.images = images;
                        handle(type, resource, params);
                    });
                else {

                    console.log(params.data.images);

                    url = `${apiUrl}/${resource}/${params.id}`;
                    options.method = "PATCH";
                    options.body = JSON.stringify(params.data);
                }
                break;
            case CREATE:
                url = `${apiUrl}/${resource}`;
                options.method = "POST";
                options.body = JSON.stringify(params.data);
                break;
            case DELETE:
                url = `${apiUrl}/${resource}/${params.id}`;
                options.method = "DELETE";
                break;
            case 'ADD_CHILD_NODE':
                url = `${apiUrl}/${resource}`;
                options.method = "POST";
                options.body = JSON.stringify({...params.data, parent: params.parentId});
                break;
            default:
                throw new Error(`Unsupported fetch action type ${type}`);
        }
        return {url, options};
    };

    /**
     * @param {Object} response HTTP response from fetch()
     * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
     * @param {String} resource Name of the resource to fetch, e.g. 'posts'
     * @param {Object} params The data request params, depending on the type
     * @returns {Object} Data response
     */
    const convertHTTPResponse = (response: any, type: string, resource: string, params: any) => {
        const {headers, json} = response;
        switch (type) {
            case GET_LIST:
            case 'GET_TREE':
            case GET_MANY_REFERENCE:
                if (!json.hasOwnProperty("numberOfElements")) {
                    throw new Error(
                        "The numberOfElements property must be must be present in the Json response"
                    );
                }
                return {
                    data: json.content,
                    total: parseInt(json.totalElements, 10)
                };
            case CREATE:
                return {data: {...params.data, id: json.id}};
            case GET_MANY:
                return {data: json.content}
            default:
                return {data: json};
        }
    };

    const handle = (type: any, resource: any, params: any): Promise<any> => {

        const {url, options} = convertDataRequestToHTTP(type, resource, params);
        return Promise.resolve(httpClient(url, options).then(response =>
            convertHTTPResponse(response, type, resource, params)
        ));
    };


    /**
     * @param {string} type Request type, e.g GET_LIST
     * @param {string} resource Resource name, e.g. "posts"
     * @param {Object} payload Request parameters. Depends on the request type
     * @returns {Promise} the Promise for a data response
     */

    return ({
        getList: (resource: any, params: any) => handle('GET_LIST', resource, params),
        getOne: (resource: any, params: any) => handle('GET_ONE', resource, params),
        getMany: (resource: any, params: any) => handle('GET_MANY', resource, params),
        getManyReference: (resource: any, params: any) =>
            handle('GET_MANY_REFERENCE', resource, params),
        update: (resource: any, params: any) => handle('UPDATE', resource, params),
        updateMany: (resource: any, params: any) =>
            handle('UPDATE_MANY', resource, params),
        create: (resource: any, params: any) => handle('CREATE', resource, params),
        delete: (resource: any, params: any) => handle('DELETE', resource, params),
        deleteMany: (resource: any, params: any) =>
            handle('DELETE_MANY', resource, params),
        addChildNode: (resource: any, params: any) => handle('ADD_CHILD_NODE', resource, params),
        getTree: (resource: any, params: any) => handle('GET_TREE', resource, params),
        deleteBranch: (resource: any, params: any) => handle('DELETE', resource, params),
        addRootNode: (resource: any, params: any) => handle('CREATE', resource, params),
    });

};


const convertFileToBase64 = (file: any) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(file.rawFile);
    }).then(base64payload => ({
        base64: base64payload,
        title: file.title
        })
    );

const convertMediaItems = async (node: any) => {
    const newPictures = node.filter(
        (p: { rawFile: any; }) => p.rawFile instanceof File
    );
    const formerPictures = node.filter(
        (p: { rawFile: any; }) => !(p.rawFile instanceof File)
    );

    console.log(newPictures);

    return Promise.all(newPictures.map(convertFileToBase64))
        .then(base64Pictures => {
                console.log(base64Pictures);
                return base64Pictures.map(picture64 => {
                    console.log(picture64);
                    return ({
                        payload: picture64.base64,
                        title: picture64.title,
                    })
                })
            }
        )
        .then(transformedNewPictures =>
            ([
                    ...formerPictures,
                    ...transformedNewPictures,
                ]
            )
        );
}